import en from './en-US'
import spa from './spa-US'

const messages = {
  ...en,
  ...spa,
};

export default messages;
